import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCmP_ALCcdZdJ8UV9Ds9PN3dQBu9capCBw",
  authDomain: "nstpv2.firebaseapp.com",
  databaseURL: "https://nstpv2-default-rtdb.firebaseio.com",
  projectId: "nstpv2",
  storageBucket: "nstpv2.firebasestorage.app",
  messagingSenderId: "364943742455",
  appId: "1:364943742455:web:8ed719287713941c784af2",
  measurementId: "G-ETFYSKTK2L"
};

// Initialize Firebase with error handling
let app, database, auth;

try {
  app = initializeApp(firebaseConfig);
  database = getDatabase(app);
  auth = getAuth(app);
  
  console.log("Firebase initialized successfully");
  
  // Check if we're in development mode
  const isDevelopment = process.env.NODE_ENV === 'development';

  // Set up emulators for local development if needed
  if (isDevelopment && window.location.hostname === 'localhost') {
    // Uncomment these lines if you're using Firebase emulators
    // import { connectAuthEmulator } from "firebase/auth";
    // import { connectDatabaseEmulator } from "firebase/database";
    // connectAuthEmulator(auth, 'http://localhost:9099');
    // connectDatabaseEmulator(database, 'localhost', 9000);
  }
} catch (error) {
  console.error("Firebase initialization error:", error);
}

export { app, database, auth }; 